import React from 'react';

import {Result} from './Result';
import {ResultSuccess} from './ResultSuccess';
import {ResultDate} from './ResultDate';

interface MessageResultProps {
  result: any;
}

const ErrorMessage = ({result}: any) => {
  const error = result?.value?.response_json?.error || 'Unknown error';

  return <>{error}</>;
};

const ResultSuccessLocal = ({result}: any) => {
  return (
    <>
      <ResultSuccess
        title="Success"
        description={result.value?.response_json?.message || '-'}
      />
      <ResultDate result={result}/>
    </>
  )
}

export const MessageResult = ({
  result,
}: MessageResultProps) => {
  /*
   * Simple text result (render just `.message`)
   */
  return (
    <Result
      result={result}
      successElement={<ResultSuccessLocal result={result}/>}
      failedTitle="Task Execution Failed"
      failedDescription={<ErrorMessage result={result}/>}
    />
  );
};

export default MessageResult;
